<template>
  <pibot-state-card :type="type">
    <template #title>
      <span :class="`${type}--text text--darken-1`">Activate profile</span>
    </template>

    <p class="font-weight-bold">
      This profile has been removed before.
    </p>

    <p class="font-weight-bold">
      By activating it, the user will regain access to PIBOT.
    </p>

    <pibot-pw-confirm
      :color="`${type} darken-1`"
      depressed
      small
      :loading="loading"
      @confirmed="handleActivation"
    >
      Activate profile

      <template #text>
        Please authorize yourself by entering your password.
      </template>
    </pibot-pw-confirm>
  </pibot-state-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'pibot-form-block-activate-profile',
  components: {
    'pibot-state-card': () => import('@/components/cards/StateCard'),
    'pibot-pw-confirm': () => import('@/components/buttons/PasswordConfirm')
  },
  data: () => ({
    type: 'warning'
  }),
  computed: {
    ...mapState({
      editing: state => state.settings.editing,
      loading: state => state.settings.loading
    })
  },
  methods: {
    ...mapActions({
      tryProfileActivate: 'settings/socket_tryProfileActivate'
    }),
    handleActivation () {
      const payload = {
        _id: this.editing._id
      }

      this.$emit('loading', true)

      this.tryProfileActivate(payload)
        .then(() => {
          this.$emit('success', 'Profile successfully activated.')
        })
        .catch(error => {
          this.$emit('error', error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    }
  }
}
</script>
